import { TRACKERS } from "@/constants/Trackers";
import { HealthInsurance } from "@/features/Patient/MedicalRecords/HealthInsurance/HealthInsurance";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/health-insurance")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_HEALTH_INSURANCE);
  },
});

function RouteComponent() {
  return <HealthInsurance />;
}
